<template>
  <div class="w">
    <div class="datails_nav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Assume' }">
          揭榜挂帅
        </el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="redTitle">
      <div>
        “揭榜挂帅” 签约项目 &nbsp;&nbsp;
        <br />
        <span class="guaing"
          >第二届中国·河南河南开放创新暨跨过技术转移大会</span
        >
      </div>
    </div>
    <div class="ChangeOneTwo">
      <span @click="ChangeYear(1)" :class="OneOrTow == 1 ? 'OneOrTow' : ''"
        >第二届大会</span
      >
      <span @click="ChangeYear(2)" :class="OneOrTow == 2 ? 'OneOrTow' : ''"
        >第一届大会</span
      >
    </div>
    <div class="relevant">
      <div class="head" v-show="OneOrTow == 1">
        <button
          v-for="(i, n) in itemBtn"
          :key="n"
          @click="changeType(n)"
          :class="inde === n ? 'focusBtnStyle' : ''"
          class="layui-btn layui-btn-primary"
        >
          {{ i.name }}
        </button>
      </div>
      <div class="show">
      <ul class="clc-ul">
        <li
          v-for="(item, index) in QyList"
          :key="index"

        >
          <img
            v-if="item.IsTechnical === 0 && OneOrTow == 1"
            src="../../assets/Assume-Image/组 4205.png"
            alt=""
          />
          <img
            v-if="item.IsTechnical != 0 && OneOrTow == 1"
            src="../../assets/Assume-Image/组 4206.png"
            alt=""
          />
          <img
            v-if="OneOrTow != 1"
            src="../../assets/Assume-Image/组 4419@2x.png"
            alt=""
          />
          <div class="showtxt">
            <h3
              class="project_title"
              :class="'contentss' + index"
            >
              {{ item.Title }}
            </h3>
            <div
            class="titlet"
            >
              签约双方
            </div>
            <div
            class="part"
            >
              {{ item.PartyA }}
            </div>

            <div
            class="paryt"
            >
              {{ item.PartyB }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    </div>
    <yedeng
      :limit.sync="QyItem.pageSize"
      :page.sync="QyItem.page"
      :total="total"
      @pagination="Quitems"
        >
        </yedeng>
  </div>
</template>
<script>
import "../../assets/Ass-css/guashui.css";
import yedeng from '../library/components/Pagination/index.vue'
import { getAction, postAction } from "@/api/api";
import qs from "qs";
import { ZhangBangList } from "@/api/url";
export default {
  data() {
    return {
      itemBtn: [
        {
          name: "全部",
        },
        {
          name: "技术攻关类",
        },
        {
          name: "成果转化类",
        },
      ],
      QyItem: {
        action: "Get_ZhangBangProjQyList",
        sort: "ID DESC",
        InptuSys: 1,
        pageSize: 12,
        page: 1,
        IsTechnical: null,
        Year: 2021,
      },
      QyList: [],
      OneOrTow: 1,
      inde: 0,
      total:0
    };
  },
  created() {
    this.Quitems();
  },
  methods: {
    //列表数据
    Quitems() {
      getAction(ZhangBangList, this.QyItem).then((res) => {
        this.QyList = res.data;
        this.total=res.count
      });
    },
    ChangeYear(n) {
      this.OneOrTow = n;
      if(n==2){
          this.QyItem.Year=2019
          this.handleCurrentChange(1)
          this.Quitems()
      }else{
          this.Quitems()
      }
    },
    changeType(n) {
      this.inde = n;
       if(n<=0){
		  this.QyItem.IsTechnical=null
          this.Quitems()
	  }else{
		  this.QyItem.IsTechnical=n-1
          this.handleCurrentChange(1)
          this.Quitems()
	  }
    },
    handleCurrentChange(val){
        this.QyItem.page=val
        this.Quitems()
    },
    infine(){
              this.Quitems()
            }
  },
     components:{
       yedeng
     }
};
</script>
<style scoped>
body {
  margin: 0rem;
  font-family: Microsoft YaHei;
  left: 0rem;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  box-sizing: border-box;
}
.w {
  width: 80rem;
  margin: 3rem auto 5rem;
  height: auto;
  overflow: hidden;
  position: relative;
}

#header {
  height: 7.4375rem;
  border-bottom: 0.0625rem solid #ffffffa9;
  background-color: #222222;
  width: 100%;
}
.datails_nav {
  text-align: left;
  height: 5.125rem;
  line-height: 5.125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.datails_nav .layui-breadcrumb a {
  color: #999 !important;
}
.lang {
  margin: 0 .625rem;
  color: #999;
}
.redTitle {
  position: relative;
  color: #333;
  height: 11rem;
  width: 40rem;
  margin: 0 auto 0;
  overflow: hidden;
}
.redTitle > div {
  text-align: center;
  font-size: 2rem;
  line-height: 3rem;
  height: auto;
  top: 2rem;
  margin: auto;
}
.show li{
  height: 17.8rem; 
  cursor: default;
  cursor: pointer;
}
.show li img{
  height: 5.625rem ;
  width:100%;
}
.show li:hover h3{
	color: #308BEC;
}
.relevant ul li{
    width: 24rem !important;
}
::v-deep .btn-prev,.btn-next{
  background: none !important;
  border-radius: 0.3125rem !important;
}
::v-deep .el-pager li{
  z-index: 9999;
  width:2.5rem !important;
  border-radius: 0.3125rem !important;
}
::v-deep .el-pagination__jump{
  margin-left: 3rem !important;
}
.guaing{
  font-size: 0.875rem; 
  color: rgba(51, 51, 51, 0.5);
}
.head{
  text-align: left;
}
.titlet{
  height: 2rem;
  font-size: 1rem;
  color: #737373;
  text-align: center;
  margin-top: -0.9375rem;
  font-weight: bold;
}
.part{
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 2rem;
  font-size: 1rem;
  color: #999;
  padding: 0 1rem;
  text-align: center;
}
.paryt{
  margin-top: 0;
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
  color: #999;
  padding: 0 1rem;
  height: 2rem;
  text-align: center;
}
.showtxt{
  height: 9.125rem;
}
.showtxt h3{
  text-align: center;
  font-size: 1.15rem;
  padding:0.9rem;
  height:4rem;
}
.itemDesc{
  height:5.2rem;
}
.show ul{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.clc-ul::after{
  content: '';
  display:block;
  width: 24rem;
}
</style>